// skills/alchemy/alchemyData.js
// Herb cleaning recipes, potion recipes, and mortar tools

// Herb cleaning - convert grimy herbs to clean herbs (quick action, low XP)
export const HERB_CLEANING = {
    GREENLEAF: {
        id: 'clean_greenleaf',
        name: 'Clean Green Leaf',
        level: 1,
        xp: 2.5,
        baseTime: 1000, // 1 second
        inputItem: 'grimy_greenleaf',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_greenleaf', quantity: 1 }
        ],
        color: '#228B22'
    },
    DUSKLEAF: {
        id: 'clean_duskleaf',
        name: 'Clean Dusk Leaf',
        level: 12,
        xp: 3.8,
        baseTime: 1000,
        inputItem: 'grimy_duskleaf',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_duskleaf', quantity: 1 }
        ],
        color: '#3CB371'
    },
    IRONBLOOM: {
        id: 'clean_ironbloom',
        name: 'Clean Ironbloom',
        level: 20,
        xp: 5,
        baseTime: 1000,
        inputItem: 'grimy_ironbloom',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_ironbloom', quantity: 1 }
        ],
        color: '#32CD32'
    },
    EMBERROOT: {
        id: 'clean_emberroot',
        name: 'Clean Emberroot',
        level: 30,
        xp: 6.3,
        baseTime: 1000,
        inputItem: 'grimy_emberroot',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_emberroot', quantity: 1 }
        ],
        color: '#7CFC00'
    },
    SANCTUM_LEAF: {
        id: 'clean_sanctum_leaf',
        name: 'Clean Sanctum Leaf',
        level: 38,
        xp: 7.5,
        baseTime: 1000,
        inputItem: 'grimy_sanctum_leaf',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_sanctum_leaf', quantity: 1 }
        ],
        color: '#00FF7F'
    },
    SUNPETAL: {
        id: 'clean_sunpetal',
        name: 'Clean Sunpetal',
        level: 45,
        xp: 8.8,
        baseTime: 1000,
        inputItem: 'grimy_sunpetal',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_sunpetal', quantity: 1 }
        ],
        color: '#2E8B57'
    },
    DEEPVINE: {
        id: 'clean_deepvine',
        name: 'Clean Deepvine',
        level: 52,
        xp: 10,
        baseTime: 1000,
        inputItem: 'grimy_deepvine',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_deepvine', quantity: 1 }
        ],
        color: '#8FBC8F'
    },
    STONEBARK: {
        id: 'clean_stonebark',
        name: 'Clean Stonebark',
        level: 60,
        xp: 11.3,
        baseTime: 1000,
        inputItem: 'grimy_stonebark',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_stonebark', quantity: 1 }
        ],
        color: '#20B2AA'
    },
    BRIGHTMAW: {
        id: 'clean_brightmaw',
        name: 'Clean Brightmaw',
        level: 65,
        xp: 12.5,
        baseTime: 1000,
        inputItem: 'grimy_brightmaw',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_brightmaw', quantity: 1 }
        ],
        color: '#ff00ff'
    },
    NIGHTVINE: {
        id: 'clean_nightvine',
        name: 'Clean Nightvine',
        level: 70,
        xp: 13.1,
        baseTime: 1000,
        inputItem: 'grimy_nightvine',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_nightvine', quantity: 1 }
        ],
        color: '#66CDAA'
    },
    GLOWSTEM: {
        id: 'clean_glowstem',
        name: 'Clean Glowstem',
        level: 75,
        xp: 13.8,
        baseTime: 1000,
        inputItem: 'grimy_glowstem',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_glowstem', quantity: 1 }
        ],
        color: '#5F9EA0'
    },
    ASHBLOOM: {
        id: 'clean_ashbloom',
        name: 'Clean Ashbloom',
        level: 78,
        xp: 14.5,
        baseTime: 1000,
        inputItem: 'grimy_ashbloom',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_ashbloom', quantity: 1 }
        ],
        color: '#4682B4'
    },
    CROWNWORT: {
        id: 'clean_crownwort',
        name: 'Clean Crownwort',
        level: 85,
        xp: 15,
        baseTime: 1000,
        inputItem: 'grimy_crownwort',
        inputQuantity: 1,
        drops: [
            { itemId: 'clean_crownwort', quantity: 1 }
        ],
        color: '#6B8E23'
    }
};

// Potion recipes - main crafting action
// Each potion uses one herb + vial_of_water, provides combat buffs
export const POTION_RECIPES = {
    FERAL_DRAFT: {
        id: 'feral_draft',
        name: 'Feral Draft',
        level: 10,
        xp: 25,
        baseTime: 3000,
        inputItem: 'clean_greenleaf',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'feral_draft', quantity: 1 }
        ],
        color: '#DC143C'
    },
    STEADY_BREW: {
        id: 'steady_brew',
        name: 'Steady Brew',
        level: 18,
        xp: 35,
        baseTime: 3000,
        inputItem: 'clean_duskleaf',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'steady_brew', quantity: 1 }
        ],
        color: '#4169E1'
    },
    GUARD_TONIC: {
        id: 'guard_tonic',
        name: 'Guard Tonic',
        level: 26,
        xp: 45,
        baseTime: 3000,
        inputItem: 'clean_ironbloom',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'guard_tonic', quantity: 1 }
        ],
        color: '#4682B4'
    },
    QUICKENING_DRAUGHT: {
        id: 'quickening_draught',
        name: 'Quickening Draught',
        level: 34,
        xp: 55,
        baseTime: 3500,
        inputItem: 'clean_emberroot',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'quickening_draught', quantity: 1 }
        ],
        color: '#FFD700'
    },
    BALANCED_INFUSION: {
        id: 'balanced_infusion',
        name: 'Balanced Infusion',
        level: 42,
        xp: 65,
        baseTime: 4000,
        inputItem: 'clean_sanctum_leaf',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'balanced_infusion', quantity: 1 }
        ],
        color: '#9370DB'
    },
    FOCUSED_ELIXIR: {
        id: 'focused_elixir',
        name: 'Focused Elixir',
        level: 48,
        xp: 75,
        baseTime: 4000,
        inputItem: 'clean_sunpetal',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'focused_elixir', quantity: 1 }
        ],
        color: '#FF4500'
    },
    SUSTAINING_BREW: {
        id: 'sustaining_brew',
        name: 'Sustaining Brew',
        level: 56,
        xp: 90,
        baseTime: 4000,
        inputItem: 'clean_deepvine',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'sustaining_brew', quantity: 1 }
        ],
        color: '#228B22'
    },
    HARDENED_INFUSION: {
        id: 'hardened_infusion',
        name: 'Hardened Infusion',
        level: 62,
        xp: 105,
        baseTime: 4500,
        inputItem: 'clean_stonebark',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'hardened_infusion', quantity: 1 }
        ],
        color: '#708090'
    },
    RALLYING_ELIXIR: {
        id: 'rallying_elixir',
        name: 'Rallying Elixir',
        level: 68,
        xp: 120,
        baseTime: 4500,
        inputItem: 'clean_brightmaw',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'rallying_elixir', quantity: 1 }
        ],
        color: '#FF1493'
    },
    VEILED_DRAUGHT: {
        id: 'veiled_draught',
        name: 'Veiled Draught',
        level: 72,
        xp: 135,
        baseTime: 5000,
        inputItem: 'clean_nightvine',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'veiled_draught', quantity: 1 }
        ],
        color: '#483D8B'
    },
    ARCANE_TINCTURE: {
        id: 'arcane_tincture',
        name: 'Arcane Tincture',
        level: 78,
        xp: 150,
        baseTime: 5000,
        inputItem: 'clean_glowstem',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'arcane_tincture', quantity: 1 }
        ],
        color: '#9400D3'
    },
    SHARPSHOT_BREW: {
        id: 'sharpshot_brew',
        name: 'Sharpshot Brew',
        level: 80,
        xp: 165,
        baseTime: 5000,
        inputItem: 'clean_ashbloom',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'sharpshot_brew', quantity: 1 }
        ],
        color: '#006400'
    },
    ASCENDANT_CONCOCTION: {
        id: 'ascendant_concoction',
        name: 'Ascendant Concoction',
        level: 90,
        xp: 200,
        baseTime: 6000,
        inputItem: 'clean_crownwort',
        inputQuantity: 1,
        secondaryItem: 'vial_of_water',
        secondaryQuantity: 1,
        drops: [
            { itemId: 'ascendant_concoction', quantity: 1 }
        ],
        color: '#FFD700'
    }
};

// Mortars - tool for alchemy speed
export const MORTARS = {
    BASIC: {
        id: 'basic_mortar',
        name: 'Basic Mortar',
        level: 1,
        speedMultiplier: 1.0,
        price: 0
    },
    PYRESTONE: {
        id: 'pyrestone_mortar',
        name: 'Pyrestone Mortar',
        level: 15,
        speedMultiplier: 1.2,
        price: 1000
    },
    BLACKIRON: {
        id: 'blackiron_mortar',
        name: 'Blackiron Mortar',
        level: 30,
        speedMultiplier: 1.4,
        price: 5000
    },
    PALE_SHARD: {
        id: 'pale_shard_mortar',
        name: 'Pale Shard Mortar',
        level: 45,
        speedMultiplier: 1.6,
        price: 25000
    },
    SKYIRON: {
        id: 'skyiron_mortar',
        name: 'Skyiron Mortar',
        level: 60,
        speedMultiplier: 1.8,
        price: 100000
    },
    VERDANT: {
        id: 'verdant_mortar',
        name: 'Verdant Mortar',
        level: 75,
        speedMultiplier: 2.0,
        price: 250000
    }
};

export default {
    HERB_CLEANING,
    POTION_RECIPES,
    MORTARS
};
